module.exports = __webpack_public_path__ + "static/media/odiopay-logo-navy-blue.ebbbc24a.svg";